export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_14.d041684b.jpg";